import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen bg-meraki-bg flex items-center justify-center">
                <div className="text-[10px] uppercase tracking-[0.3em] text-meraki-gold animate-pulse">Loading...</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}
